import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c102f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-visual" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-color" }, null, -1))
const _hoisted_3 = { class: "neon-card" }
const _hoisted_4 = { class: "neon-card-center" }
const _hoisted_5 = { class: "mb-24 mt-0 text-bold text-center" }
const _hoisted_6 = { class: "text-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.state.consentTitleText), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.state.consentDisplayText), 1)
      ])
    ])
  ]))
}